import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getInstalacionesPadre`, method: 'GET', body: null, token: token})
}
